import React from 'react';
import { CameraSettingForm } from '../CameraSettingForm';
import { AssignedCamera } from 'core/models/layout';
import { SettingFormGroup } from '../SettingFormGroup';
import { CameraDevice, MediaDevice } from 'core/models/mediaDevice';

export type CameraSettingFormGroupProps = {
    groupName: string;
    keyBase?: string;
    assignedCameras: AssignedCamera[];
    duplicateCameras: Set<MediaDevice.Tag>;
    cameraDevices: CameraDevice[] | undefined;
    min?: number;
    max?: number;
    onChange: (assignedCameras: AssignedCamera[]) => void;
    getVideoConfig?: (mediaDeviceId: MediaDevice.Id) => Promise<Partial<MediaDevice.VideoConfig>>;
    putVideoConfig?: (mediaDeviceId: MediaDevice.Id, config: Partial<MediaDevice.VideoConfig>) => Promise<void>;
}

export const CameraSettingFormGroup = (props: CameraSettingFormGroupProps) => {
    const { keyBase = 'key', assignedCameras, duplicateCameras, cameraDevices, min, onChange, getVideoConfig, putVideoConfig } = props;

    function replace<T>(xs: T[], i: number, x: T) {
        return xs.map((y, j) => j == i ? x : y);
    }

    function remove<T>(xs: T[], i: number) {
        return xs.filter((_, j) => j != i);
    }

    return (
        <SettingFormGroup {...props} addLabel={'one more camera...'} forms={assignedCameras}>
            {
                assignedCameras.map((current, i) =>
                    <CameraSettingForm
                        key={`${keyBase}-${i}`}
                        assignedCamera={current}
                        duplicate={current.tag != undefined && duplicateCameras.has(current.tag)}
                        cameras={cameraDevices}
                        isRemovable={assignedCameras.length > (min ?? 0)}
                        onChange={x => onChange(replace(assignedCameras, i, x))}
                        onRemove={() => onChange(remove(assignedCameras, i))}
                        getVideoConfig={getVideoConfig}
                        putVideoConfig={putVideoConfig}
                    />)
            }
        </SettingFormGroup>
    );
};
